import { render, staticRenderFns } from "./HolidaysStatistics.vue?vue&type=template&id=563856db&scoped=true&"
import script from "./HolidaysStatistics.vue?vue&type=script&lang=js&"
export * from "./HolidaysStatistics.vue?vue&type=script&lang=js&"
import style0 from "@/styles/components/statistics.styl?vue&type=style&index=0&id=563856db&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563856db",
  null
  
)

export default component.exports